import { useContext } from 'react';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import i18nContext from 'components/i18n-context';
import { ReactComponent as PhoneIcon } from 'assets/phone-icon.svg';
import { AuthorizationBackButton } from 'components/common/AuthorizationBackButton/AuthorizationBackButton';
import './Confirmations.scss';

const PushNotification2FA = ({ authStore }) => {
  const i18n = useContext(i18nContext);

  const handleSwitchToAnotherMethod = () => authStore.setIsShowSwitchConfirmationMethodScreen(true);

  return (
    <div className={'authorization-form push-notification-wrapper'} id={'form1'}>
      <PhoneIcon className={'svg-phone-icon registration-icon'} />
      <h1 className={'authorization-title'}>{i18n.getMessage('pushNotification2fa.title')}</h1>

      <p className={'push-notification-description'}>{i18n.getMessage('pushNotification2fa.description')}</p>
      <div className={'push-notification-another-method-wrapper'}>
        <p className={'push-notification-no-notifications-description'}>
          {i18n.getMessage('pushNotification2fa.noNotifications')}
        </p>
        <button className={'unset link-normal without-margin'} onClick={handleSwitchToAnotherMethod}>
          {i18n.getMessage('sms.switchToAnotherMethod')}
        </button>
      </div>
      <AuthorizationBackButton type={'login'} confirmationType={authStore.confirmationActionType} />
    </div>
  );
};

PushNotification2FA.propTypes = {
  authStore: MobXPropTypes.observableObject
};

export default inject('authStore')(observer(PushNotification2FA));
